module.exports = __webpack_public_path__ + "assets/image/backPlate_skee1024.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/image/backPlate_skee1024.png
// module id = 169
// module chunks = 0